// extracted by mini-css-extract-plugin
module.exports = {"rowLayout":"NumberInput_rowLayout__3iJ9i","inputTitle":"NumberInput_inputTitle__1nxkz","inputContainer":"NumberInput_inputContainer__1Tjco"};